import Swiper from '../vendors/swiper.min.js';

export default class Sliders {
  static mainSlider() {
    let options = {
      loop: true,
      effect: 'fade',
      centeredSlides: true,
      speed: 2000,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        1024: {
          slidesPerView: 1
        }
      }
    }
    return new Swiper('.hero__container', options);
  }

  static createSlider(sliderEl, thumbEl) {
    let options = {
      loop: true,
      effect: 'fade',
      speed: 2000,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      }
    };

    let slider = new Swiper(sliderEl, options);
    let thumbs = document.querySelectorAll(thumbEl);

    const initThumbs = (slider, thumbs) => {
      [...thumbs].map(t => t.addEventListener('click', e => {
        let currentIndex = [...thumbs].indexOf(e.currentTarget);
        slider.slideTo(currentIndex + 1, 1000);
      }));
    }

    initThumbs(slider, thumbs);
  }


  static spaSliders() {
    this.createSlider('.s-slider01', '.s-thumbnails01 .thumbnails__item');
    this.createSlider('.s-slider02', '.s-thumbnails02 .thumbnails__item');
    this.createSlider('.s-slider03', '.s-thumbnails03 .thumbnails__item');
  }

  static facilitiesSlider() {
    this.createSlider('.f-slider', '.f-thumbnails .thumbnails__item');
  }
}